var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVoiceStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    style: {
      display: "block"
    },
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-3.3333 -3.3333 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1772",
    d: "M8.66667 16.5833C4.93471 16.5833 3.06874 16.5833 1.90937 15.424C0.750001 14.2646 0.750001 12.3986 0.750001 8.66667C0.750001 4.93471 0.750001 3.06874 1.90937 1.90937C3.06874 0.750001 4.93471 0.750001 8.66667 0.750001C12.3986 0.750001 14.2646 0.750001 15.424 1.90937C16.5833 3.06874 16.5833 4.93471 16.5833 8.66667C16.5833 12.3986 16.5833 14.2646 15.424 15.424C14.2646 16.5833 12.3986 16.5833 8.66667 16.5833Z",
    strokeWidth: 1.5,
    stroke: "#242428"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoiceStop);
export default __webpack_public_path__ + "static/media/icon-voice-stop.ab616bc8d6935eac51ed74c25b718fe7.svg";
export { ForwardRef as ReactComponent };